import { ConfirmDialog } from "@/components/ui/ConfirmDialog";

/** What is about to be removed: one named document, or a number of them. */
export type DeleteRequest =
  | { kind: "one"; fileId: string; name: string }
  | { kind: "many"; fileIds: string[] };

/**
 * The explicit step before anything is removed. Names the document or the
 * count, and can be cancelled without effect.
 */
export function DeleteConfirmation({
  request,
  onCancel,
  onConfirm,
}: {
  request: DeleteRequest | null;
  onCancel: () => void;
  onConfirm: (request: DeleteRequest) => void;
}) {
  const title =
    request === null
      ? ""
      : request.kind === "one"
        ? `Delete ${request.name}?`
        : `Delete ${request.fileIds.length} documents?`;
  return (
    <ConfirmDialog
      open={request !== null}
      title={title}
      description="It comes out of the library and out of everything the analysis runs against. To bring it back, upload it again."
      actionLabel="Delete"
      destructive
      onCancel={onCancel}
      onConfirm={() => {
        if (request !== null) onConfirm(request);
      }}
    />
  );
}
